export function startViewTransition(callback: () => void) {
  if (document.startViewTransition && document.visibilityState === "visible") {
    document.startViewTransition(callback)
  } else {
    callback()
  }
}
